import { render, staticRenderFns } from "./LayersTreeItemElement.vue?vue&type=template&id=6f06c735&scoped=true"
import script from "./LayersTreeItemElement.vue?vue&type=script&lang=ts&setup=true"
export * from "./LayersTreeItemElement.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./LayersTreeItemElement.vue?vue&type=style&index=0&id=6f06c735&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f06c735",
  null
  
)

export default component.exports